import React from "react"
import { Link } from "gatsby"

import Layout from "../components/layout"
import SEO from "../components/seo"
import { SLSlider } from "../components/slider/slider"
import { RichText } from "../components/richtext/richtext"
import { Map } from "../components/map"
import styles from "./county.module.css"
import { NavButton } from "../components/navbutton/navbutton"

const CountyTemplate = props => {
  const MainText = RichText(props.pageContext.mainText)
  return (
    <Layout>
      <SEO title={`${props.pageContext.countyName} Locksmith Service`} />
      <div className={styles.content}>
        <div className={styles.main}>{MainText}</div>
        <aside className={styles.aside}>
          {RichText(props.pageContext.reviewText)}

          <NavButton
            isSideContact={true}
            className={styles.reviewButton}
            label={"Review Us"}
            useAnchor={true}
            to={props.pageContext.reviewLink}
          />

          <div style={{ display: "flex", justifyContent: "center" }}>
            <Map>{props.pageContext.map.map}</Map>
          </div>
        </aside>
      </div>
      <div style={{ display: "flex", justifyContent: "center" }}>
        <div style={{ maxWidth: "90%" }}>
          <SLSlider images={props.pageContext.imageCarousel.images} />
        </div>
      </div>
    </Layout>
  )
}

export default CountyTemplate
